import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ContributionContainer from "./ContributionContainer";
import Contribution from "../../models/Contribution";
import { getPubmedEntriesPerArticle } from "../../state/selectors/PubmedUserEntries.selectors";
import SourceEntity from "../Publications/models/SourceEntity";
import Article from "../Publications/models/Article";

function ContributionList({
  className,
  contributions,
  article,
  shouldShowComments,
  shouldShowLikes,
  showPlaceholderIfEmpty,
  sourceEntity,
  shouldShowTread,
  ...rest
}) {
  return (
    <>
      {contributions?.length ? (
        <div data-tab="abstract" className={className}>
          {contributions.map((x, i) => (
            <ContributionContainer
              {...rest}
              key={`${x.id}-${i}`}
              shouldShowComments={shouldShowComments}
              sourceEntity={sourceEntity}
              shouldShowLikes={shouldShowLikes}
              contribution={x}
              article={article}
              shouldShowTread={shouldShowTread}
            />
          ))}
        </div>
      ) : null}

      {!contributions?.length && showPlaceholderIfEmpty ? (
        <div className="tw-text-blueGray-400">No Classifications</div>
      ) : null}
    </>
  );
}

ContributionList.propTypes = {
  className: PropTypes.string,
  contributions: PropTypes.arrayOf(PropTypes.instanceOf(Contribution)),
  article: PropTypes.instanceOf(Article),
  shouldShowComments: PropTypes.bool,
  shouldShowLikes: PropTypes.bool,
  showPlaceholderIfEmpty: PropTypes.bool,
  sourceEntity: PropTypes.instanceOf(SourceEntity),
  shouldShowTread: PropTypes.bool,
};

ContributionList.defaultProps = {
  className: "",
  contributions: [],
  article: null,
  shouldShowComments: true,
  shouldShowLikes: true,
  showPlaceholderIfEmpty: false,
  sourceEntity: null,
  shouldShowTread: true,
};

const mapStateToProps = (state, props) => {
  const { pubmedId, sourceEntity } = props;
  const { id: entId } = sourceEntity || {};
  const entries = getPubmedEntriesPerArticle(state) || [];
  const entryMap = entries || new Map();
  const articleEntriesAll = entryMap.get(`${pubmedId}`) || [];
  const articleEntries = articleEntriesAll.filter(
    (x) => String(x.variantId) === String(entId)
  );

  return { contributions: articleEntries };
};

export default connect(mapStateToProps, {})(React.memo(ContributionList));
